"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pane = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
function paddingCalculator(value) {
    if (value === true) {
        return '8px 16px';
    }
    else if (typeof value === 'number') {
        return `${value * 4}px ${value * 4}px`;
    }
    else if (typeof value === 'string') {
        const vs = value.match(/(\d)\s+(\d)/);
        if (vs) {
            return `${Number(vs[1]) * 4}px ${Number(vs[2]) * 4}px`;
        }
        else {
            return value;
        }
    }
    else {
        return 0;
    }
}
function paddingXCalculator(value) {
    if (value === true) {
        return '0 16px';
    }
    else if (typeof value === 'number') {
        return `0 ${value * 4}px`;
    }
}
function paddingYCalculator(value) {
    if (value === true) {
        return '8px 0';
    }
    else if (typeof value === 'number') {
        return `0 ${value * 4}px`;
    }
}
const makeMyClasses = (props) => ({
    root: {
        position: 'relative',
        textAlign: props.right ? 'right' : undefined,
        display: props.center ? 'flex' : undefined,
        alignItems: props.center ? 'center' : undefined,
        justifyContent: props.center ? 'center' : undefined,
        cursor: props.onClick ? 'pointer' : undefined,
        flex: props.shrink
            ? '0 0 auto'
            : props.grow
                ? (typeof props.grow === 'number' ? props.grow : 1) + ' 1 0%'
                : '0 0 auto',
        background: props.paper ? lib_palette_1.default.White.main : undefined,
        border: props.paper ? `1px solid ${lib_palette_1.default.LineGrey.main}` : 'none',
        borderRadius: props.paper ? 8 : 0,
        opacity: props.hidden ? 0 : 1,
        transition: 'opacity 0.33s',
        overflow: props.scroll ? 'auto' : props.visible ? 'visible' : 'hidden',
        overflowX: props.scrollX ? 'auto' : undefined,
        overflowY: props.scrollY ? 'auto' : undefined,
        padding: props.hidden
            ? 0
            : props.padding
                ? paddingCalculator(props.padding)
                : props.paddingX
                    ? paddingXCalculator(props.paddingX)
                    : props.paddingY
                        ? paddingYCalculator(props.paddingY)
                        : '',
    },
});
exports.Pane = react_1.default.forwardRef((props, ref) => {
    const { classes, style, onClick, onMouseEnter, onMouseDown, onMouseLeave, onScroll, children } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [props], classes);
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { ref: ref, onClick: onClick, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onScroll: onScroll, style: style, className: myCss.root }, children)), [myCss, onClick, onScroll, onMouseDown, onMouseEnter, onMouseLeave, children, ref, style]);
});
exports.default = exports.Pane;
